import { ReactElement } from 'react';
import MaterialRating from '../../../../../../../../common/material-rating/material-rating';
import MaterialOwner from '../../../../../../../../common/material/material-long/template/components/material-owner/material-owner';
import AddToFolderIconButton from '../../../../components/add-to-folder-icon-button/add-to-folder-icon-button';
import MaterialTitle from '../../../../components/material-title/material-title';
import './main.scss';

type MainProps = { item: Material; index: number; link: string; shouldShowFolder?: boolean; internalPath?: string };

const Main = (props: MainProps): ReactElement => {
    const { item, index, link, shouldShowFolder, internalPath } = props;

    const averageRating = item.averageRating || 0;

    return (
        <main className='main'>
            <MaterialTitle item={item} index={index} link={link} internalPath={internalPath} />

            {averageRating > 0 && <MaterialRating rating={averageRating} voices={item.totalFeedbacks} short />}

            <MaterialOwner item={item} />

            {shouldShowFolder && <AddToFolderIconButton item={item} />}
        </main>
    );
};

export default Main;
